var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0013 7.66797V5.66797C15.0013 4.5634 14.1059 3.66797 13.0013 3.66797H5.66797C4.5634 3.66797 3.66797 4.5634 3.66797 5.66797V13.0013C3.66797 14.1059 4.5634 15.0013 5.66797 15.0013H7.66797M15.0013 7.66797H16.3346C17.4392 7.66797 18.3346 8.5634 18.3346 9.66797V16.3346C18.3346 17.4392 17.4392 18.3346 16.3346 18.3346H9.66797C8.5634 18.3346 7.66797 17.4392 7.66797 16.3346V15.0013M15.0013 7.66797H9.66797C8.5634 7.66797 7.66797 8.5634 7.66797 9.66797V15.0013",
    stroke: "#2C2C2C",
    strokeOpacity: 0.7,
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.93eb6913a6f77a854e4e7437d4a2158d.svg";
export { ForwardRef as ReactComponent };